
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const addActionComment = async (actionId, commentDetails) => {
   

    if(actionId && parseInt(actionId)  === 0){
        return {error:'invalid action id, ignored'}
    }

    if(commentDetails && commentDetails.trim().length === 0){
        return {error:'empty comment, ignored.'}
    }
  
    const response = await authenticatedFetch(`${config.API_BASE_URL}/actionComments`, {
        method: 'POST',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify({
                actionId: parseInt(actionId), 
                comment: commentDetails
            })
      });
      
      if (response.ok) {
        const responseData = await response.json();
            return responseData; 
      } else {
        throw new Error(`Authentication failed`);
      }
  
  };